export const succeservaringAnalyticsEvents = [
  'succeservaringGetoond',
  'startopdrachtClicked',
] as const;
